import React from 'react';

const qrCode = require('@/public/assets/qrcode/二维码.png');
const qrCode2x = require('@/public/assets/qrcode/二维码@2x.png');
const qrCode3x = require('@/public/assets/qrcode/二维码@3x.png');

const computer = require('@/public/assets/qrcode/电脑.png');
const computer2x = require('@/public/assets/qrcode/电脑@2x.png');
const computer3x = require('@/public/assets/qrcode/电脑@3x.png');

interface Props {
    tab: 0 | 1;
    onClick: (event: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}
const SwitchTab: React.FC<Props> = props => {
    const {tab = 0, onClick} = props;
    return (
        <div className="web-login-switch-tab">
            {!tab && (
                <img
                    srcSet={`${qrCode},
                        ${qrCode2x} 2x,
                        ${qrCode3x} 3x,`}
                    src={qrCode3x}
                    alt="switch"
                    className="switch-img"
                />
            )}
            {!!tab && (
                <img
                    srcSet={`${computer},
                        ${computer2x} 2x,
                        ${computer3x} 3x,`}
                    src={computer3x}
                    alt="switch"
                    className="switch-img"
                />
            )}
            <div className="triangle" />
            <div role="button" onClick={onClick} tabIndex={0} className="switch-btn" />
        </div>
    );
};

export default SwitchTab;
